import React from "react";
import TrialCard from "~/components/components/TrialCard.jsx";

export default function AppWrapper({ children }) {
  return (
    <>
      {children}
      <TrialCard />
    </>
  );
}
